import axios from '../axiosConfig.jsx'

export async function getPartners() {
    return await axios.get(`/admins/partners`).then(res => res.data)
}

export async function getPartnersById(partnerId) {
    return await axios.get(`/admins/partners/${partnerId}`).then(res => res.data)
}